import _extends from "@babel/runtime/helpers/extends";
import _objectWithoutProperties from "@babel/runtime/helpers/objectWithoutProperties";

/* eslint-disable jsx-a11y/no-static-element-interactions */
import React from "react";
import { MobileNavList, Overlay } from "..";

var MobileNav = function MobileNav(_ref) {
  var overlay = _ref.overlay;

  var _overlay$context$data = overlay.context.data,
      items = _overlay$context$data.items,
      rest = _objectWithoutProperties(_overlay$context$data, ["items"]);

  return React.createElement(Overlay, {
    context: overlay
  }, React.createElement("div", {
    className: "side-nav",
    onClick: function onClick(evt) {
      return evt.stopPropagation();
    }
  }, React.createElement(MobileNavList, _extends({
    items: items,
    hideOverlay: overlay.hide
  }, rest))));
};

export default MobileNav;